import { SALES_TEAM_POSITIONS } from '@/data/sales-team-positions';
import { CHART_GROUPS } from './charts/index.js';

export {
    CHART_CURRENCIES,
    CHARTS_MENU_TO,
    findChartByPath,
    flattenChartItems,
    isChartsView,
} from './charts/index.js';

const customers = CHART_GROUPS.find((group) => group.id === 'customers');

if (customers && !customers.items.some((item) => item.id === 'retention')) {
    customers.items.push({
        id: 'retention',
        title: 'Retention',
        icon: 'ri-line-chart-line',
        to: '/charts/retention',
        scope: 'read_charts_customers',
        bypassPositions: SALES_TEAM_POSITIONS,
        description: 'Company-wide LTV, gross and net revenue retention, and logo churn.',
    });
}

export { CHART_GROUPS };
